<div class="push-right">
  <div class="sidebar-mobile">
    <div class="menu-icon-mobile" exceptclick>
      <mat-icon (click)="toggleSidebar()">menu</mat-icon>
    </div>
    <div class="menu-mobile hide-mobile-menu" clickOutside (clickOutside)="clickingOutside()">
      <mat-nav-list>
        <ng-container *ngFor="let child of menuConfigs">
          <ng-container *ngIf="child.title" [ngTemplateOutlet]="menuItemTemplate"
            [ngTemplateOutletContext]="{ item: child }">
          </ng-container>
        </ng-container>
        <!-- <div mat-list-item *ngIf="!isAgent" [routerLink]="['/notifications']" class="item-href"
          [title]="'Notifications' | translate">
          <div [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="icon-container">
            <mat-icon class="notifications">notifications<div *ngIf="hasNew" class="unread"></div></mat-icon>
          </div>
          <div class="title">{{'Notifications' | translate}}</div>
        </div> -->
      </mat-nav-list>
    </div>
  </div>
  <div class="sidebar" [ngStyle]="{'height': 'calc(100% - 15px)'}">
    <mat-nav-list>
      <ng-container *ngFor="let child of menuConfigs">
        <ng-container *ngIf="child.title" [ngTemplateOutlet]="menuItemTemplate"
          [ngTemplateOutletContext]="{ item: child }">
        </ng-container>
      </ng-container>
      <!-- <div mat-list-item *ngIf="!isAgent" [routerLink]="['/notifications']" class="item-href"
        [title]="'Notifications' | translate">
        <div [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="icon-container">
          <mat-icon class="notifications">notifications<div *ngIf="hasNew" class="unread"></div></mat-icon>
        </div>
        <div class="title">{{'Notifications' | translate}}</div>
      </div> -->
    </mat-nav-list>
  </div>
</div>

<ng-template #menuItemTemplate let-item="item" let-parentItem="parentItem">
  <ng-container *ngIf="!item.submenu && !item.permission" [ngTemplateOutlet]="menuItemInnerTemplate"
    [ngTemplateOutletContext]="{ item: item, parentItem: parentItem  }"></ng-container>
  <ng-template *ngIf="!item.submenu && item.permission" [ngxPermissionsOnly]="item.permission">
    <ng-container [ngTemplateOutlet]="menuItemInnerTemplate"
      [ngTemplateOutletContext]="{ item: item, parentItem: parentItem  }"></ng-container>
  </ng-template>
  <ng-container *ngIf="item.submenu && !item.permission" [ngTemplateOutlet]="menuItemInnerTemplateSub"
    [ngTemplateOutletContext]="{ item: item, parentItem: parentItem  }"></ng-container>
  <ng-template *ngIf="item.submenu && item.permission" [ngxPermissionsOnly]="item.permission">
    <ng-container [ngTemplateOutlet]="menuItemInnerTemplateSub"
      [ngTemplateOutletContext]="{ item: item, parentItem: parentItem  }"></ng-container>
  </ng-template>
</ng-template>

<ng-template #menuItemInnerTemplate let-item="item" let-parentItem="parentItem">
  <ng-container *ngIf="(showAlerts && item.title == 'Alerts') ||  item.title != 'Alerts'">
    <a *ngIf="item.target" mat-list-item href="{{item.page}}" target="{{item.target}}" class="item-href"
      [title]="item.title">
      <mat-icon *ngIf="item.icon">{{item.icon}}</mat-icon>
      <div class="title">{{ item.title | translate }}</div>
    </a>
    <div *ngIf="!item.target" mat-list-item [routerLink]="[item.page]" class="item-href" [title]="item.title">
      <div *ngIf="item.data.hasNotifications && hasNewMessages" class="red-dot">
        <!-- <span
          *ngIf="hasNewMessages > 99">99</span><span *ngIf="hasNewMessages <= 99">{{hasNewMessages}}</span> -->
      </div>
      <div [routerLinkActive]="'active'"
        [class.active]="item.data.type == 'community' && currentRoute.includes('community')"
        [routerLinkActiveOptions]="{ exact: item.data.exact }" class="icon-container">
        <mat-icon *ngIf="item.icon">{{item.icon}}</mat-icon>
      </div>
      <div class="title">{{ item.title | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #menuItemInnerTemplateSub let-item="item" let-parentItem="parentItem">
  <!-- <ng-container *ngIf="(showCommunity && item.title == 'Community') || item.title != 'Community'"> -->
  <div [class.submenu-active]="showSubmenu" class="sub-item-href">
    <div class="icon-container" (click)="toggleSubmenu()">
      <mat-icon *ngIf="item.icon">{{item.icon}}</mat-icon>
      <div *ngIf="item.data.hasNotifications && hasNewMessages" class="red-dot"><span
          *ngIf="hasNewMessages > 99">99</span><span *ngIf="hasNewMessages <= 99">{{hasNewMessages}}</span></div>
      <mat-icon *ngIf="!showSubmenu" class="toggle-arrow">arrow_drop_down</mat-icon><mat-icon *ngIf="showSubmenu"
        class="toggle-arrow">arrow_drop_up</mat-icon>
    </div>
    <div class="title" [class.expanded]="showSubmenu" (click)="toggleSubmenu()">{{ item.title | translate }}</div>
    <!-- <ng-container *ngIf="showSubmenu"> -->
    <ng-container *ngFor="let child of item.submenu">
      <ng-template *ngIf="child.permission" [ngxPermissionsOnly]="child.permission">
        <div class="submenu" [@collapse]="!showSubmenu" [class.expanded]="showSubmenu" [routerLink]="[child.page]">
          {{child.title}}
        </div>
      </ng-template>
    </ng-container>
    <!-- </ng-container> -->
  </div>
  <!-- </ng-container> -->
  <!-- <div class="nested-menu">
    <a mat-list-item (click)="addExpandClass(item.target)">
      <mat-icon matListItemIcon class="sidenav-icon">{{item.icon}}</mat-icon> {{ item.title | translate }}
    </a>
    <ul class="nested submenu" [class.expand]="showMenu === item.target">
      <li *ngFor="let child of item.submenu">
        <ng-container *ngIf="child.title" [ngTemplateOutlet]="menuItemTemplate"
          [ngTemplateOutletContext]="{ item: child }"></ng-container>
      </li>
    </ul>
  </div> -->
</ng-template>